import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar.json';
import en from './locales/en.json';

// Get stored language from localStorage (synced with uiStore)
function getStoredLanguage(): 'ar' | 'en' {
  try {
    const stored = localStorage.getItem('maksab-ui-settings');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.state?.language === 'en' || parsed.state?.language === 'ar') {
        return parsed.state.language;
      }
    }
  } catch {
    // ignore
  }
  return 'ar';
}

const initialLanguage = getStoredLanguage();

// Apply initial direction immediately
document.documentElement.dir = initialLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = initialLanguage;

i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: 'ar',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
